export default [
  // 拼团商品信息
  {
    path: '/groupon/:spuId(\\d+)',
    name: 'groupon',
    meta: { type: 'page', title: '拼团商品详情', stParams: {} },
    component: () => import(/* webpackChunkName: 'coupon' */ 'views/product/detail/index/index.vue')
  },
  // 拼团详情
  {
    path: '/groupon/detail',
    name: 'grouponDetail',
    meta: { type: 'page', title: '拼团详情', shareBtn: true, stParams: {} },
    component: () => import(/* webpackChunkName: 'coupon' */ 'views/groupon/detail')
  },
  // 支付成功
  {
    path: '/groupon/paySuccess',
    name: 'paySuccess',
    meta: { type: 'page', title: '拼团详情', shareBtn: true, stParams: {} },
    component: () => import(/* webpackChunkName: 'coupon' */ 'views/groupon/detail')
  },
  {
    path: '/groupon/prize',
    name: 'prize',
    meta: { type: 'page', title: '中奖名单', stParams: {} },
    component: () => import(/* webpackChunkName: 'coupon' */ 'views/onecentgroup/index')
  }
]
